<!-- デバイスの使用頻度のサンプル datasetsとかlabels入れたら表示できる-->
<script>
import { Pie } from "vue-chartjs";
export default {
  extends: Pie,
  name: "DeviceFrequency",
  type: "pie",
  data() {
    return {
      data: {
        datasets: [
          {
            data: [10, 20, 30],
            backgroundColor: ["#ff9896", "#aec7e8", "#98df8a"],
          },
        ],
        labels: ["pc", "smartphone", "tablet"],
        options: {
          responsive: true,
          maintainAspectRatio: false,
        },
      },
    };
  },
  computed: {
    deviceFrequencyList: function () {
      return this.$store.getters["domain/deviceFrequencyList"];
    },
  },
  watch: {
    deviceFrequencyList(val) {
      if (val) {
        this.overwriteGraphData(val);
      }
      this.renderChart(this.data, this.options);
    },
  },
  mounted() {
    const val = this.$store.getters["domain/deviceFrequencyList"];
    this.overwriteGraphData(val);
    this.renderChart(this.data, this.options);
  },
  methods: {
    overwriteGraphData: function (val) {
      let deviceCount = [];
      for (let i = 0; i < val.length; i++) {
        const data = val[i];
        deviceCount.push(data.pc_count);
        deviceCount.push(data.smartphone_count);
        deviceCount.push(data.tablet_count);
      }
      this.$set(this.data.datasets[0], "data", deviceCount);
    },
  },
};
</script>
